<script setup>
import { ref, onUpdated, defineProps, defineEmits } from "vue"
import useOperators from "../../use/useOperators"
import usePersianTools from "../../use/usePersianTools"

const props = defineProps({
  operator: {
    required: true,
    type: Object,
  },
})

const operatorData = ref({
  id: props.operator.id,
  password: "",
  password_confirmation: "",
})

const emit = defineEmits(["update:modelValue", "close"])

const { show, loading, errors, changePasswordOperator, closeModal } =
  useOperators(props, emit, operatorData)

const { convertPersianToEnglish } = usePersianTools()

onUpdated(() => {
  operatorData.value = {
    id: props.operator.id,
    password: "",
    password_confirmation: "",
  }
})
</script>

<template>
  <!-- edit operator modal  -->
  <b-modal
    v-model="show"
    @close="closeModal()"
    id="showModal"
    hide-footer
    title="تغییر کلمه عبور اپراتور"
    header-class="p-3 bg-light"
    class="v-modal-custom"
    centered
    no-close-on-backdrop
  >
    <b-overlay
      variant="white"
      opacity="0.75"
      blur="2px"
      :show="loading"
      spinner-variant="success"
      rounded="sm"
    >
      <b-card>
        <b-form
          id="changePasswordForm"
          class="tablelist-form"
          autocomplete="off"
          @submit.prevent="changePasswordOperator"
        >
          <div class="mb-3">
            <label for="password" class="form-label">کلمه عبور</label>
            <input
              type="password"
              id="password"
              class="form-control"
              placeholder="کلمه عبور (پسورد)"
              v-model="operatorData.password"
              @input="
                convertPersianToEnglish(
                  $event.target.value,
                  operatorData,
                  'password'
                )
              "
            />
            <div v-if="errors">
              <div class="invalid-feedback" v-if="errors.password">
                <span>{{ errors.password[0] }}</span>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <label for="confirm-password" class="form-label"
              >تایید کلمه عبور</label
            >
            <input
              type="password"
              id="confirm-password"
              class="form-control"
              placeholder="تایید کلمه عبور (تکرار کلمه عبور)"
              v-model="operatorData.password_confirmation"
              @input="
                convertPersianToEnglish(
                  $event.target.value,
                  operatorData,
                  'password_confirmation'
                )
              "
            />
          </div>

          <div class="hstack gap-2 justify-content-end">
            <b-button
              type="button"
              id="closemodal"
              variant="light"
              @click="closeModal"
            >
              بستن
            </b-button>
            <b-button type="submit" variant="success">تغییر کلمه عبور</b-button>
          </div>
        </b-form>
      </b-card>
    </b-overlay>
  </b-modal>
</template>
